module.exports = __webpack_public_path__ + "img/12_86.5bff941c.png";